export const classes = {
  card: 'w-full h-full grow overflow-auto min-w-[350px] p-6 bg-gradient-to-br from-blue-3/10 to-blue-1/40 from-50%',
  list: 'w-full min-h-0 overflow-auto',
  emptyCard: 'flex flex-col items-center',
  emptyMessage:
    'w-full text-center text-xl p-8 text-grey-8 dark:text-mauve-1 font-normal',
  addList: 'max-w-[500px] w-full',
};
